/* The Money Duck — interactive bits (no framework) */

(function () {
  'use strict';

  /* ---------- FAQ accordion ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.faq-q');
    if (!btn) return;
    var item = btn.closest('.faq-item');
    if (!item) return;
    var wasOpen = item.classList.contains('open');
    // Close siblings within the same list.
    var list = item.parentElement;
    if (list) {
      list.querySelectorAll('.faq-item.open').forEach(function (el) { el.classList.remove('open'); });
    }
    if (!wasOpen) item.classList.add('open');
  });

  /* ---------- Method jars: active state ---------- */
  document.addEventListener('click', function (e) {
    var jar = e.target.closest('.jar');
    if (!jar) return;
    var group = jar.parentElement;
    if (!group) return;
    group.querySelectorAll('.jar.active').forEach(function (el) { el.classList.remove('active'); });
    jar.classList.add('active');
  });

  /* ---------- Mobile drawer ---------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-drawer-open]');
    var close = e.target.closest('[data-drawer-close]');
    var drawer = document.querySelector('.mobile-drawer');
    if (!drawer) return;
    if (open) { drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); }
    if (close) { drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); }
    // Close drawer on link tap.
    if (e.target.closest('.mobile-links a')) {
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
    }
  });

  /* ---------- Conversation cards deck ---------- */
  function layoutDeck(stage) {
    var cards = stage.querySelectorAll('.conv-card');
    var total = cards.length;
    var idx = parseInt(stage.dataset.idx || '0', 10);
    cards.forEach(function (card, i) {
      var offset = ((i - idx) + total) % total;
      var transform = 'translate(-50%,-50%)';
      var opacity = 1;
      var z = 10;
      if (offset === 0) {
        transform = 'translate(-50%, -50%) rotate(-3deg)';
        z = 30;
      } else if (offset === 1) {
        var tx = window.innerWidth <= 720 ? -47 : -42;
        var rot = window.innerWidth <= 720 ? 3 : 4;
        transform = 'translate(' + tx + '%, -52%) rotate(' + rot + 'deg)';
        z = 20;
        opacity = 0.85;
      } else if (offset === 2) {
        var rot2 = window.innerWidth <= 720 ? -5 : -7;
        transform = 'translate(-50%, -54%) rotate(' + rot2 + 'deg)';
        z = 10;
        opacity = 0.65;
      } else {
        opacity = 0;
        z = 0;
        transform = 'translate(-50%, -50%) scale(0.9)';
      }
      card.style.transform = transform;
      card.style.zIndex = z;
      card.style.opacity = opacity;
      card.style.pointerEvents = offset === 0 ? 'auto' : 'none';
    });
    var counter = stage.parentElement.querySelector('[data-deck-counter]');
    if (counter) {
      counter.textContent = (idx + 1) + ' / ' + total;
    }
  }

  function initDecks() {
    document.querySelectorAll('.cards-stage').forEach(function (stage) {
      stage.dataset.idx = '0';
      layoutDeck(stage);
      var wrap = stage.closest('[data-deck]');
      if (!wrap) return;
      var next = wrap.querySelector('[data-deck-next]');
      var prev = wrap.querySelector('[data-deck-prev]');
      var total = stage.querySelectorAll('.conv-card').length;
      function go(delta) {
        var i = parseInt(stage.dataset.idx, 10);
        stage.dataset.idx = String(((i + delta) % total + total) % total);
        layoutDeck(stage);
      }
      if (next) next.addEventListener('click', function () { go(1); });
      if (prev) prev.addEventListener('click', function () { go(-1); });
      stage.addEventListener('click', function (e) {
        var card = e.target.closest('.conv-card');
        if (!card) return;
        // Only the top card is interactive.
        if (card.style.pointerEvents !== 'auto') return;
        go(1);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDecks);
  } else {
    initDecks();
  }
})();
